<template>
    <div class="bng-bonus" v-if="bonuses && activeBonus">
        <h1 v-if="showTitle" class="title">{{"components.common.bonus.playThrough.title" | translate}}</h1>
        <div class="bonus-info">
            <p>
                {{"components.common.bonus.playThrough.created" | translate}}:
                <b>{{activeBonus.created | localDatetime("")}}</b>
            </p>
            <p>
                {{"components.common.bonus.playThrough.startAmount" | translate}}:
                <b>{{activeBonus.startAmount | currency(player.balance.currency)}}</b>
            </p>
            <p>
                {{"components.common.bonus.playThrough.currentAmount" | translate}}:
                <b>{{activeBonus.currentAmount | currency(player.balance.currency)}}</b>
            </p>
            <div class="bonus-progress">
                <div class="progressbar">
                    <div
                        class="progressbar-title"
                    >{{"components.common.bonus.playThrough.betProgress" | translate}}</div>
                    <div class="progressbar-progress">
                        <div
                            class="progress-bar"
                            :style="{width: activeBonus.betProgressPercent + '%'}"
                        >
                            <div class="progress-bar-inner">
                                <b>{{progress + '%'}}</b>
                            </div>
                        </div>
                    </div>
                    <div class="progressbar-legend">
                        <div class="progressbar-legend-start">
                            <b>{{activeBonus.betProgress | currency(player.balance.currency)}}</b>
                        </div>
                        <div class="progressbar-legend-end">
                            <b>{{activeBonus.betRequirement | currency(player.balance.currency)}}</b>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';

import balanceService from '../../../../../_common/services/balance.service';

import Description from '../description/description.vue';

export default {
    name: 'profile-bonus',
    components: { Description },
    props: {
        showTitle: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            loading: false,
            bonuses: null,
            activeBonus: null
        };
    },
    computed: {
        player() {
            return Vue.state.player.get();
        },
        progress() {
            var p = parseInt((this.activeBonus && this.activeBonus.betProgressPercent) || 0);
            return Math.max(Math.min(p, 100), 0);
        }
    },
    async created() {
        await this.refresh();
    },
    methods: {
        async refresh() {
            this.loading = true;
            this.bonuses = await balanceService.getBonuses();
            this.activeBonus = this.bonuses.active;
            this.loading = false;
        }
    }
};
</script>



// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/common/bonus/bonus.vue